import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
window.supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line getter-return
    get: function get() {
      window.supportsPassive = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {
  console.error('e: ', e);
}

function globalTouchHandler(e) {
  e.preventDefault();
}

function size(obj) {
  // eslint-disable-next-line no-restricted-syntax
  for (var key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      return true;
    }
  }

  return false;
}

var ScrollLocker = /*#__PURE__*/function () {
  function ScrollLocker(el) {
    _classCallCheck(this, ScrollLocker);

    this.el = el;
    this.calcRect();
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchMove = this._onTouchMove.bind(this);
    this.el.addEventListener('touchstart', this._onTouchStart, true);
    this.el.addEventListener('touchmove', this._onTouchMove, true);
  }

  _createClass(ScrollLocker, [{
    key: "calcRect",
    value: function calcRect() {
      this.scrollHeight = this.el.scrollHeight;
      this.offsetHeight = this.el.offsetHeight;
      this.locked = this.scrollHeight === this.offsetHeight;
    }
  }, {
    key: "_onTouchStart",
    value: function _onTouchStart(e) {
      this.lastY = e.touches[0].pageY;
    } // eslint-disable-next-line consistent-return

  }, {
    key: "_onTouchMove",
    value: function _onTouchMove(e) {
      e.stopPropagation();

      if (this.locked) {
        e.preventDefault();
        return false;
      }

      var scrollTop = this.el.scrollTop;
      var touch = e.touches[0];
      var currY = touch.pageY;
      var direction = currY - this.lastY;

      if (scrollTop === 0 && direction > 0) {
        e.preventDefault();
      } else if (this.scrollHeight <= this.offsetHeight + scrollTop && direction < 0) {
        e.preventDefault();
      }

      this.lastY = currY;
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.el.removeEventListener('touchstart', this._onTouchStart, true);
      this.el.removeEventListener('touchmove', this._onTouchMove, true);
    }
  }], [{
    key: "lock",
    value: function lock(el) {
      var lockerId = el.dataset.lockerId;

      if (lockerId) {
        this.unlock(el);
      } else {
        // eslint-disable-next-line no-multi-assign, no-param-reassign
        lockerId = el.dataset.lockerId = this.genLockerId();
      }

      if (!size(this.lockers)) {
        document.addEventListener('touchmove', globalTouchHandler, window.supportsPassive ? {
          passive: false
        } : false);
      } // eslint-disable-next-line no-multi-assign


      var lockers = this.lockers[lockerId] = [];

      _toConsumableArray(el.querySelectorAll('[data-skip-locker]')).forEach(function (v) {
        lockers.push(new ScrollLocker(v));
      });

      return lockerId;
    }
  }, {
    key: "unlock",
    value: function unlock(el) {
      var lockerId = el.dataset.lockerId;

      if (!lockerId) {
        return;
      }

      var lockers = this.lockers[lockerId];
      delete this.lockers[lockerId];

      if (Array.isArray(lockers)) {
        lockers.forEach(function (v) {
          return v.unlock();
        });
      }

      if (!size(this.lockers)) {
        document.removeEventListener('touchmove', globalTouchHandler, window.supportsPassive ? {
          passive: false
        } : false);
      }
    }
  }, {
    key: "genLockerId",
    value: function genLockerId() {
      // eslint-disable-next-line no-plusplus
      return "locker_".concat(++this.SEQ);
    }
  }]);

  return ScrollLocker;
}();

export { ScrollLocker as default };
ScrollLocker.lockers = {};
ScrollLocker.SEQ = 0;